// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tab__container-a7c316 {
  margin: 0 8px;
  cursor: pointer;
  position: relative;
}

.Tab__container-a7c316:hover > .Tab__title-cd1fd6 {
  color: var(--base-110);
}

@supports (display: block) {
  .Tab__container-a7c316:focus-visible {
    background-color: var(--base-20);
  }
  .Tab__container-a7c316:focus-visible > .Tab__title-cd1fd6 {
    color: var(--base-110);
  }
}
.Tab__title-cd1fd6 {
  display: inline-block;
  color: var(--base-80);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  padding: 4px 0 6px;
}

.Tab__container-a7c316.Tab__active-a6be84 > .Tab__title-cd1fd6 {
  color: var(--base-110);
}

.Tab__underline-a49efa {
  display: inline-block;
  height: 0;
  background-color: transparent;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom: 2px solid transparent;
}

.Tab__container-a7c316.Tab__active-a6be84 > .Tab__underline-a49efa {
  border-color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Tabs/Tab/Tab.style.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE;IACE,gCAAA;EACF;EAEA;IACE,sBAAA;EAAF;AACF;AAGA;EACE,qBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,qBAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;AADF;;AAIA;EACE,qCAAA;AADF","sourcesContent":[".container {\n  margin: 0 8px;\n  cursor: pointer;\n  position: relative;\n}\n\n.container:hover > .title {\n  color: var(--base-110);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    background-color: var(--base-20);\n  }\n\n  .container:focus-visible > .title {\n    color: var(--base-110);\n  }\n}\n\n.title {\n  display: inline-block;\n  color: var(--base-80);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  padding: 4px 0 6px;\n}\n\n.container.active > .title {\n  color: var(--base-110);\n}\n\n.underline {\n  display: inline-block;\n  height: 0;\n  background-color: transparent;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  border-bottom: 2px solid transparent;\n}\n\n.container.active > .underline {\n  border-color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tab__container-a7c316`,
	"title": `Tab__title-cd1fd6`,
	"active": `Tab__active-a6be84`,
	"underline": `Tab__underline-a49efa`
};
module.exports = ___CSS_LOADER_EXPORT___;
